import sadIcon from "../../assets/sad.svg";
import React from "react";
import { Container } from "./styles";

export const FinalizeCampaign = () => {
  const handleChangePage = () => {
    window.location.href = "https://pagtel.com.br/recargacorreios";
  };

  return (
    <Container>
      <img src={sadIcon} alt="sad" />
      <h1>Opss... Campanha Finalizada.</h1>
      <button onClick={() => handleChangePage()}>
        <h4>
          <a href="https://pagtel.com.br/recargacorreios">Voltar</a>
        </h4>
      </button>
    </Container>
  );
};
